export default [
    {
        path: '/model/scenario/dimensions',
        name: 'dimensionsList',
        component: () => import('@/views/dimensions/list/dimensionsView.vue'),
        meta: {
            resource: 'Data',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/dimension/data/:dimensionId/old',
        name: 'dimensionsEdit',
        component: () => import('@/views/dimensions/edit/dimensionEdit.vue'),
        props: true
    },
    {
        path: '/model/scenario/dimension/data/:dimensionId',
        name: 'dimensionsDataLake',
        component: () => import('@/views/dimensions/edit/dimensionDataLake.vue'),
        props: true,
        meta: {
            resource: 'Data',
            action: 'create',
        },
    },
    {
        path: '/model/scenario/dimension/calculated-drivers/old',
        name: 'dimensionsCalculatedDriversOld',
        component: () => import('@/views/dimensions/calculated-drivers/calculatedDriversView.vue'),
        props: true
    },
    {
        path: '/model/scenario/dimension/calculated-drivers',
        name: 'dimensionsCalculatedDrivers',
        component: () => import('@/views/dimensions/calculated-drivers/beta/calculatedDriversView.vue'),
        props: true,
        meta: {
            resource: 'Data',
            action: 'create',
        },
    }
]
